
interface SvgFacturaProps {
  className?: string;

}

const SvgFactura: React.FC<SvgFacturaProps> = ({ className }) => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      className={`h-8 w-8 ${className}`}
      fill="white"  // Asegura que el icono sea blanco
      stroke="currentColor"
      strokeWidth={1}
    >
      <path d="M5,15c0-1.103,.897-2,2-2h6.5c.276,0,.5,.224,.5,.5s-.224,.5-.5,.5H7c-.551,0-1,.449-1,1v2c0,.551,.449,1,1,1h7.5c.276,0,.5,.224,.5,.5s-.224,.5-.5,.5H7c-1.103,0-2-.897-2-2v-2Zm.5-5h4c.276,0,.5-.224,.5-.5s-.224-.5-.5-.5H5.5c-.276,0-.5,.224-.5,.5s.224,.5,.5,.5Zm0-4h4c.276,0,.5-.224,.5-.5s-.224-.5-.5-.5H5.5c-.276,0-.5,.224-.5,.5s.224,.5,.5,.5Zm11.5,17.5c0,.276-.224,.5-.5,.5H5.5c-2.481,0-4.5-2.019-4.5-4.5V4.5C1,2.019,3.019,0,5.5,0h5.515c1.735,0,3.368,.676,4.597,1.904l3.484,3.485c.824,.824,1.413,1.857,1.702,2.987,.038,.15,.005,.309-.09,.431s-.24,.193-.395,.193h-5.813c-1.379,0-2.5-1.122-2.5-2.5V1.087c-.322-.058-.651-.087-.985-.087H5.5c-1.93,0-3.5,1.57-3.5,3.5v15c0,1.93,1.57,3.5,3.5,3.5h11c.276,0,.5,.224,.5,.5ZM13,6.5c0,.827,.673,1.5,1.5,1.5h5.129c-.275-.712-.697-1.361-1.24-1.904l-3.484-3.485c-.552-.551-1.199-.97-1.904-1.243V6.5Zm8.79,10.281l-3.422-.55c-.793-.127-1.368-.803-1.368-1.605,0-.896,.729-1.626,1.626-1.626h2.8c.623,0,1.204,.335,1.517,.875,.139,.24,.445,.32,.683,.183,.239-.138,.321-.444,.183-.683-.49-.848-1.402-1.375-2.382-1.375h-.926v-1.5c0-.276-.224-.5-.5-.5s-.5,.224-.5,.5v1.5h-.874c-1.448,0-2.626,1.178-2.626,2.626,0,1.296,.93,2.387,2.21,2.593l3.422,.55c.793,.127,1.368,.803,1.368,1.605,0,.896-.729,1.626-1.626,1.626h-2.8c-.623,0-1.204-.335-1.517-.875-.139-.24-.448-.321-.683-.183-.239,.138-.321,.444-.183,.683,.49,.848,1.402,1.375,2.382,1.375h.926v1.5c0,.276,.224,.5,.5,.5s.5-.224,.5-.5v-1.5h.874c1.448,0,2.626-1.178,2.626-2.626,0-1.296-.93-2.387-2.21-2.593Z" />
    </svg>
  );

};
export default SvgFactura;
